<template>
  <v-expansion-panel >
    <!-- :class="validateWhere() ? '' : 'red--text'" -->
    <v-expansion-panel-header>
      <div class="d-flex smart-item">
        <v-layout text-right wrap>
          <v-flex pt-2 pb-2 pa-2>
            <v-layout wrap>
              <v-flex xl3 lg3 md3 xs12 class="smart-item-title">
                <span
                  class="display-24"  
                >
                <!-- :class="validateWhere() ? '' : 'red--text'" -->
                  {{ text }} <span class="primary--text" >*</span>
                </span>
                <!-- <span
                  v-if="required && !displayedSelections"
                  class="red--text display-14 d-block"
                  >* {{ t(`titles.requiredField`) }}
                </span> -->
              </v-flex>
              <v-divider
                vertical
                class="ml-1"
                v-show="$vuetify.breakpoint.smAndUp"
              />

              <v-flex
                class="display-18 smart-item-fields py-1"
                align-self-center
              >
                {{ selectionA }}
                <!-- <span v-if="selectionB && selectionA">,</span>
                {{ selectionB }} -->
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="mt-1 pa-0">
      <v-flex xs12>
      
          <v-layout wrapmt-2>
          <v-flex md4 xs12 my-2>
            <LocationWithRange 
              :isRounded="true" 
              class="primary--text"
              :selectedLocation="autoSuggestModelA"
              :selectedRange="distanceModelA"
              :placeholder="selectionA ? autoSuggestModelA.NameInHebrew : 'הכנס מיקום'" 
              @distanceSelected="updateDistanceSelectionA" 
              @updateLocation="updateSuggestedLocationA"
            />            
          </v-flex>
        </v-layout>
        <!-- <small class="d-block">
          <span v-show="!selectionA"> *כתובת משרה</span>
        </small> -->
        <!-- <v-layout wrap my-2>
          <v-flex xs12
            ><v-btn
              text
              class="pr-0 font-weight-medium pointer"
              @click="seccondAddress = !seccondAddress"
              ><span
                v-html="seccondAddress ? ' - ' : ' + '"
                class="d-inline-block px-2"
              >
                +
              </span>
              <span
                v-html="seccondAddress ? 'הסרת מיקום' : ' הוספת מיקום'"
              ></span>
            </v-btn>
          </v-flex>

          <v-flex md4 xs12 nx-2 v-show="seccondAddress">
           
            <LocationWithRange 
              :isRounded="true" 
              class="primary--text"
              :selectedLocation="autoSuggestModelB"
              :selectedRange="distanceModelB"
              :placeholder="selectionB ? autoSuggestModelB.NameInHebrew : 'הכנס מיקום'" 
              @distanceSelected="updateDistanceSelectionB" 
              @updateLocation="updateSuggestedLocationB"
              ref="geo2"
            />            
          </v-flex>
        </v-layout> -->
      </v-flex>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import LocationWithRange from '@/components/Forms/Form_Fields/LocationWithRange.vue';

export default {
  components: {
    LocationWithRange
  },

  props: {
    items: {
      type: Array,
      default: Array,
    },

    text: {
      type: String,
      default: '',
    },

    cautionMsg: {
      type: String,
      default: '',
    },

    showMsgIfLessThen: {
      type: Number,
    },

    required: {
      type: Boolean,
    },
    locations: {
      type: Array,
      required: false,
    },
  },

  data() {
    return {
      selections: {},
      selectionA: '',
      selectionB: '',
      selectionsCodes: [],
      displayedSelections: null,
      autoSuggestModelA: null,
      distanceModelA: { Code: 3, NameInHebrew: '30 ק"מ' }, // DEFAULT_DISTANCE,
      autoSuggestModelB: null,
      distanceModelB: { Code: 3, NameInHebrew: '30 ק"מ' }, // DEFAULT_DISTANCE,
      seccondAddress: false,
    }
  },
  computed: {},
  watch: {
    /* Clear autoSuggestModelB on hide seccondAddress */
    seccondAddress() {
      if(this.autoSuggestModelB && !this.seccondAddress) {
        this.$refs.geo2.model = null
        this.handleDeletePrevLocationB()
      }
    },
    autoSuggestModelA() {      
      this.selectionA = this.autoSuggestModelA?.NameInHebrew 
      if(!this.autoSuggestModelA) this.distanceModelA = { Code: 3, NameInHebrew: '30 ק"מ' }
      this.updateSelections()
    },

    autoSuggestModelB() {
      this.selectionB = this.autoSuggestModelB?.NameInHebrew 
      this.updateSelections()
    },
    distanceModelA() {
      this.updateSelections()
    },
    distanceModelB() {
      this.updateSelections()
    },
  },

  mounted() {
    this.initValues()
  },

  methods: {
    updateSelections() {
      this.selections = {
        ...(this.selectionA && {
          [this.autoSuggestModelA.GeoLexId]: this.distanceModelA?.Code,
        }),
        ...(this.selectionB && {
          [this.autoSuggestModelB.GeoLexId]: this.distanceModelB?.Code,
        }),
      }
      this.$emit('selectionsUpdated', this.selections)

      this.validateWhere()
    },
    initValues() {
      let keys = Object.keys(this.locations).length
      if (this.locations && keys > 0) {
        this.autoSuggestModelA = this.locations[0].Key
        this.distanceModelA = {
          Code: this.locations[0].Value.Id,
          NameInHebrew: this.locations[0].Value.Value,         
        }      
        // if (keys > 1) {
        //   this.autoSuggestModelB = this.locations[1].Key
        //   this.distanceModelB = {
        //     Code: this.locations[1].Value.Id,
        //     NameInHebrew: this.locations[1].Value.Value,         
        //   }      
        //   this.seccondAddress = true
        // }
      } else {
        console.log('locations none')
      }
    },
    updateDistanceSelectionA(value) {
      this.distanceModelA = value
    },

    updateSuggestedLocationA(value) {
      this.autoSuggestModelA = value
    },

    // updateDistanceSelectionB(value) {
    //   this.distanceModelB = value
    // },

    // updateSuggestedLocationB(value) {
    //   this.autoSuggestModelB = value
    // },

    // handleDeletePrevLocationB() {
    //   this.autoSuggestModelB = null
    //   this.distanceModelB = { Code: 3, NameInHebrew: '30 ק"מ' }
    // },

    validateWhere() {   
      if  
        ( this.autoSuggestModelA &&  this.autoSuggestModelA.NameInHebrew && this.autoSuggestModelA.GeoLexId ) {
       return true
      } 
      else {
        this.autoSuggestModelA = null
        return false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#smart-manager .v-expansion-panel-content__wrap * {
  padding-bottom: 0;
}
.caution {
  color: red;
  align-self: flex-start;
}

.check-item {
  margin: 5px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
}

#range-location .v-text-field--placeholder {
  color: $primary !important;
}

@media only screen and (min-width: 960px) {
  .check-item {
    background: #f2f2f2;
    margin: 5px;
    height: 100px;

    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    margin-left: 30px;
  }
}

@media only screen and (min-width: 600px) {
}
</style>
